import { LEAVE_RULES_VIOLATION_REASON } from 'domain/shared/leave';
import { DefaultDropdownProps, EnumDropdown } from 'framework/form';

const RulesViolationReasonDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <EnumDropdown
      placeholder="Choose reason for business rules violation"
      options={LEAVE_RULES_VIOLATION_REASON}
      {...props}
    />
  );
};

export default RulesViolationReasonDropdown;
